<div class="main" [ngClass]="{ 'is-portrait': isPortraitDevice }">
    <div class="container" [ngClass]="{ 'is-portrait': isPortraitDevice }">
        <div class="headlines">
            <h1 *ngIf="!isPortraitDevice" class="headline-m">
                {{ additionalDataTitle | translate }}
            </h1>

            <p class="subtitle-m">
                {{ additionalDataSubtitle | translate }}
            </p>
        </div>

        <form class="form" [formGroup]="formGroup">
            <div class="form-field">
                <p-selectButton
                    id="marital"
                    formControlName="maritalStatus"
                    class="p-selectButtonCustom"
                    [options]="maritalStatusOptions"
                    optionLabel="label"
                    optionValue="code"
                    (onOptionClick)="onClickMaritalStatusButton($event)"
                    data-testid="maritalStatusSelectButton"
                ></p-selectButton>
            </div>

            <div class="more-options">
                <button *ngIf="!showMoreMaritalStatus" id="more-options" ripple="true" class="more-options" type="button" (click)="onClickMaritalStatus(true)">
                    <span class="more-options">{{ moreOptions | translate }}</span>
                </button>

                <button *ngIf="showMoreMaritalStatus" id="less-options" ripple="true" class="more-options" type="button" (click)="onClickMaritalStatus(false)">
                    <span class="more-options">{{ lessOptions | translate }}</span>
                </button>
            </div>

            <div *ngIf="!showMoreChildrenNumber" class="form-children">
                <div class="frame-1">
                    <span class="text-paragraph">{{ childrenNumber | translate }} </span>
                    <i class="ri-information-line" style="color: blue"></i>
                </div>
                <div class="row-childrens"[ngClass]="{ 'is-portrait': isPortraitDevice }">
                    <p-selectButton
                        id="childrenNumber"
                        formControlName="childrenNumber"
                        class="p-selectButtonCustomChildrenNumber children-number"
                        [options]="childrenNumberList.slice(0, 4)"
                        (onOptionClick)="onClickChildrenNumberButton($event)"
                        [ngClass]="{ 'is-portrait': isPortraitDevice }"
                        data-testid="childrenNumberSelectButton"
                    ><ng-template let-option>
                        <div [attr.data-testid]="option.id">{{ option.label }}</div>
                    </ng-template>
                        <span class="p-button-label-cero">{{ childrenNumber }}</span>
                    </p-selectButton>
                    <button
                        ripple="true"
                        class="button-choice button-more"
                        type="button"
                        value="childrenNumber(4)"
                        id="childrenNumberMore"
                        (click)="onClickChildrenNumberMore()"
                        [ngClass]="{ 'is-portrait': isPortraitDevice }"
                    >
                        <span class="p-button-label-more">{{ childrenNumberList.slice(4) }}</span>
                    </button>
                </div>
            </div>

            <div *ngIf="showMoreChildrenNumber" class="form-children">
                <div class="frame-1">
                    <span class="text-paragraph">{{ childrenNumber | translate }} </span>
                    <i class="ri-information-line" style="color: blue"></i>
                </div>

                <div class="inputs">
                    <div class="form-input">
                        <input
                            type="text"
                            class="input"
                            formControlName="childrenNumber"
                            id="childrenNumberInput"
                            name="childrenNumberInput"
                            (keyup)="onChangeChildrenNumberInput($event)"
                        />
                        <label class="input-label" for="childrenNumber">Nº de hijos</label>

                        <div *ngIf="this.formGroup.controls.childrenNumber.valid" class="input-icon">
                            <i class="ri-check-line class-icono"></i>
                        </div>
                    </div>

                    <div>
                        <button
                            pripple=""
                            class="button-choice button-more"
                            type="button"
                            value="childrenNumber"
                            id="i"
                            (click)="onClickChildrenNumberLess()"
                            [ngClass]="{ 'is-portrait': isPortraitDevice }"
                        >
                            <span class="p-button-label-more">Menos</span>
                        </button>
                    </div>
                </div>
            </div>
        </form>

        <div class="actions">
            <button
                *ngIf="!isPortraitDevice"
                pripple=""
                class="button-secondary button-next"
                type="button"
                [disabled]="backButtonDisabled"
                (click)="onClicButtonBack()"
            >
                <span class="ri-arrow-left-line p-button-icon p-button-icon-left ng-star-inserted"></span>
                <span class="p-button-label-right">{{ backButton | translate }}</span>
            </button>

            <button
                pripple=""
                class="button-primary button-next"
                type="button"
                [disabled]="continueButtonDisabled"
                (click)="onClicButtonContinue()"
                [ngClass]="{ 'is-portrait': isPortraitDevice }"
            >
                <span class="p-button-label-left">{{ continueButton | translate }}</span>
                <span class="ri-arrow-right-line p-button-icon p-button-icon-right ng-star-inserted"></span>
            </button>
        </div>
    </div>

    <div *ngIf="isPortraitDevice">
        <app-footer></app-footer>
    </div>

    <div class="chat-layer">
        <app-chat-layer></app-chat-layer>
    </div>
</div>
